import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { TypeGetOrdersParams, TypeGetOrdersResponse } from '~/types/delivery-agency.types';

/**
 * [배송 주문 관리] 배송 주문 리스트 조회 API
 */
export const fetchOrders = async (params: TypeGetOrdersParams): Promise<TypeGetOrdersResponse> => {
  const { data } = await axiosInstance.get<TypeGetOrdersResponse>(API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS, { params });
  return data;
};

type UseGetOrdersQueryOptions = {
  params: TypeGetOrdersParams;
  enabled?: boolean;
};

/**
 * [배송 주문 관리] 배송 주문 리스트 조회 Query Hook
 */
export const useGetOrdersQuery = ({ params, enabled = true }: UseGetOrdersQueryOptions) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.orders(params),
    queryFn: () => fetchOrders(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
